/**
 * The methodology that will be written into the data task.
 *
 * There is no server-rendered default anymore — `CommitPanel` starts the field empty and the user either
 * types into it or asks "Generate with AI" (a real agent turn over the chat connection) to fill it in. The
 * mechanical "Source / Transformations applied" derivation the mapping service renders
 * (`methodologySummaryHtml`) still exists, but only in the Working Data History tray now, not here.
 */

/**
 * The request to commit, with the methodology folded in.
 *
 * Applied at commit time rather than by mutating `validated.request`, because that object is the thing the
 * dry run validated and this panel's whole contract is that the bytes committed are the bytes validated.
 * Folding it in here keeps `rows` — the only part Java validates — untouched and identical.
 *
 * Always applied, including an empty string: Java validates rows, and this is prose stored beside them, so
 * there is nothing to re-validate and no default to fall back to if it is blank.
 */
export function requestWithMethodology(request, methodology) {
  if (!request) return request;
  return {
    ...request,
    provenance: { ...(request.provenance ?? {}), methodologySummaryHtml: methodology ?? "" },
  };
}
